import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-personalization-email-setup',
  templateUrl: './customer-personalization-email-setup.component.html',
  styleUrls: ['./customer-personalization-email-setup.component.css']
})
export class CustomerPersonalizationEmailSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
